import { checkFileTotalSize } from 'utils';
import { Grid, Typography } from '@material-ui/core';
import { initialEmployeeState, toastMessages } from 'config/constants';
import { useEmployeeFunctions } from 'contexts/EmployeeContext';
import { useHistory } from 'react-router-dom';
import EmployeeForm from 'components/EmployeeForm';
import MaiaLogo from 'components/MaiaLogo';
import RegisterLayout from 'pages/RegisterLayout';
import routes from 'config/routes';
import sideImage from '_assets/register/team.svg';
import toast from 'react-hot-toast';
import useStyles from './styles';

function RegisterEmployee() {
  const classes = useStyles();
  const history = useHistory();

  const { createEmployee } = useEmployeeFunctions();

  const handleSubmitForm = async ({ values, picture }) => {
    let pictureData = null;
    if (picture?.file) {
      if (!checkFileTotalSize([picture.file])) {
        toast.error(toastMessages.error.UPLOAD_PICTURE_SIZE_LIMIT);
        return { pictureSizeError: true };
      }

      let formData = new FormData();
      formData.append('file', picture?.file);
      pictureData = { data: formData, url: picture?.url };
    }

    const { created, pictureUpdated } = await createEmployee(values, pictureData);
    if (created) history.push(routes.home.root);

    return { pictureUpdated, success: created };
  };

  const SideComponent = () => (
    <Grid container direction="column" style={{ height: 'auto' }}>
      <Grid container item justifyContent="center">
        <MaiaLogo />
      </Grid>

      <Grid container item justifyContent="center" style={{ marginTop: '8vh' }}>
        <img src={sideImage} alt="Identity" width={200} />
      </Grid>

      <Grid container item justifyContent="center" style={{ marginTop: '3vh' }}>
        <Typography className={classes.text} align="center" variant="h3">
          Vous disposez d’une équipe de moniteurs ?
        </Typography>
        <Typography className={classes.text} align="center" variant="h3" style={{ marginTop: '3vh' }}>
          Pas de problème vous pourrez les ajouter plus tard dans la section Paramètres/équipe
        </Typography>
      </Grid>
    </Grid>
  );

  return (
    <RegisterLayout SideComponent={<SideComponent />}>
      <Grid container direction="column" style={{ height: 'auto' }}>
        <Grid className={classes.header} container item justifyContent="center">
          <Grid className={classes.title} container item xs={12} md={9} justifyContent="center">
            <Typography variant="h1">Votre équipe</Typography>
          </Grid>

          <Grid className={classes.title} container item xs={12} md={9} justifyContent="center">
            <Typography align="center" variant="h2">
              Créons votre premier moniteur qui réalisera les prestations
            </Typography>
          </Grid>
        </Grid>

        <Grid container item justifyContent="center" style={{ flexGrow: 1 }}>
          <EmployeeForm
            disabled={false}
            employee={initialEmployeeState}
            onCancel={() => history.push(routes.home.root)}
            onSubmit={handleSubmitForm}
          />
        </Grid>
      </Grid>
    </RegisterLayout>
  );
}

export default RegisterEmployee;
